/* istanbul ignore file */
/* Public API for the ShareAndEmbedComponent. Please only import things from this directory that are exported here! */
import ShareAndEmbed, { ShareAndEmbedProps } from './components/ShareAndEmbed';
import './index.scss';

export { ShareAndEmbed };

export default ShareAndEmbed;
